import {Container, Col, Row } from "react-bootstrap";
import ContactFormSide from "./components/ContactFormSide";
import FormContainer from "./components/FormContainer";



const RowTwo = () => {

  return (
    <>
      <Container>

      <Row
        className="my-4 mx-auto contact-wrapper"
      >
        <Col
          xs={12}
          md={12}
          lg={6}
          className="d-none d-lg-block p-0"
        >
          <ContactFormSide />
        </Col>

        <Col
          xs={12}
          md={12}
          lg={6}
          className="p-0"
        >
          <FormContainer />
        </Col>
      </Row>
        </Container>

    </>
  );
};

export default RowTwo;
